<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog title="修改分类" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="广告图片" prop="imageId" :label-width="formLabelWidth" :rules="[{ required: true, message: '请上传图片' }]">
        <el-row>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <div v-if="form.imageId!=0" class="img">
            <img :src="filePath" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="跳转链接" prop="url" :label-width="formLabelWidth">
        <el-input v-model="form.url" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="间隔时长" prop="time" :rules="[{ required: true,min:0 ,message: '请输入大于0的数字' }]" :label-width="formLabelWidth">
        <el-input placeholder="请输入时长" type="number" v-model.Number="form.time">
          <template slot="append">时</template>
        </el-input>
      </el-form-item>
      <el-form-item label="是否开启" :label-width="formLabelWidth">
        <el-radio-group v-model="form.is_show">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>
</template>

<script>
import BulletboxApi from "@/api/bulletbox.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        // province_id: "",
        // city_id: "",
        // region_id: "",
        url: "",
        time: "",
        is_show: 1,
        imageId: ""
      },
      filePath: "",
      formRules: {
        imageId: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur"
          }
        ]
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false
    };
  },
  props: ["open_edit", "editform"],
  created() {
    this.dialogVisible = this.open_edit;
    this.form.pop_id = this.editform.model.pop_id;
    this.form.url = this.editform.model.url;
    this.form.imageId = this.editform.model.imageId;
    this.filePath = this.editform.model.image.filePath;
    this.form.time = this.editform.model.time;
    this.form.is_show = this.editform.model.is_show;
  },
  methods: {
    /*修改用户*/
    addUser() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          BulletboxApi.BulletEdit(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "修改成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.imageId = e[0].fileId;
        this.filePath = e[0].filePath;
      }
      this.isupload = false;
    }
  }
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketing/bulletbox/edit.vue